import { PureComponent } from "react";
import { Flex } from "@chakra-ui/react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import Dialog from "src/components/Dialog";
import NavigationBar from "src/components/NavigationBar";

const MAX_IMAGE_HEIGHT = 363;
const MAX_IMAGE_WIDTH = 632;

export default class Cropper extends PureComponent {
  state = {
    isProcessing: false,
    imageWidth: 0,
    imageHeight: 0,
    crop: {}
  };

  // If you setState the crop in here you should return false.
  onImageLoaded = (image) => {
    this.imageRef = image;
    const { naturalWidth, naturalHeight } = image;
    const initialCrop = {
      unit: "%",
      height: 50,
      x: 25,
      y: 25,
      aspect: 1
    };
    let imageWidth,
      imageHeight = "auto";

    const containerAspectRation = MAX_IMAGE_WIDTH / MAX_IMAGE_HEIGHT;
    const imageAspectRation = naturalWidth / naturalHeight;
    if (imageAspectRation >= containerAspectRation) {
      imageWidth = MAX_IMAGE_WIDTH;
    } else {
      imageHeight = MAX_IMAGE_HEIGHT;
    }
    this.setState({ imageWidth, imageHeight, crop: initialCrop });
    return false;
  };

  onCrop = async () => {
    const { crop } = this.state;
    this.setState({ isProcessing: true });
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageDataUrl = await this.getCroppedImg(
        this.imageRef,
        crop,
        "avatar.jpeg"
      );
      this.props.onCrop(croppedImageDataUrl);
    } else this.props.onBack();
  };

  onCropChange = (crop, percentCrop) => {
    this.setState({ crop });
  };

  getCroppedImg(image, crop, fileName) {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    return canvas.toDataURL("image/jpeg");
  }

  render() {
    const { crop, isProcessing, imageWidth, imageHeight } = this.state;
    const { onBack, src } = this.props;

    return (
      <>
        <Dialog isOpen={isProcessing} isProcessing={isProcessing} />
        <NavigationBar
          actionButton={{
            labelKey: "buttons.crop",
            onClick: this.onCrop
          }}
          onBack={onBack}
        />
        {src && (
          <Flex
            width="100%"
            height={MAX_IMAGE_HEIGHT + "px"}
            bg="black"
            alignItems="center"
            justifyContent="center"
          >
            <ReactCrop
              src={src}
              crop={crop}
              onImageLoaded={this.onImageLoaded}
              onChange={this.onCropChange}
              circularCrop={true}
              maxWidth={720}
              maxHeight={720}
              minWidth={64}
              minHeight={64}
              imageStyle={{
                width: imageWidth,
                height: imageHeight
              }}
            />
          </Flex>
        )}
      </>
    );
  }
}
